

import PPromise from 'p-progress';
import { IAuthenticationManager } from "../../interface/authentication";
import IMediumDto from "../../model/MediumDto.if";
import { getMedia, getMediaNoResponse } from '../api/media';


export function downloadAll(media: Array<IMediumDto>, auth: IAuthenticationManager): PPromise<void> {
    return new PPromise(async function(resolve, reject, progress) {
        try {
            const accessToken = await auth.renew();
            let fetchError: string|null = null;

            progress(0.01);

            const totalBytesToDownload = media.reduce((total: number, medium: IMediumDto) => (total + medium.mediumSize), 0);

            let progressUptoThisFetch = 0; /* as we loop through keep a running counter of all weightings up to this point */

            /* download each fetch in order sequentially */
            for ( let idx = 0; idx < media.length; idx++ ) {
                const medium = media[idx];
                /* how much is this request worth overall to the progress */
                const progressWeighting = medium.mediumSize/totalBytesToDownload;
                const fetch = getMediaNoResponse(accessToken, medium.id)
                    .onProgress(progressNow => {
                        const progressCb = progressUptoThisFetch + (progressNow * progressWeighting);
                        progress(Math.max(Math.min(progressCb, 1.0), 0.0));
                    });

                try {
                    await fetch;
                } catch (error) {
                    console.error(`Download all media failed: ${JSON.stringify(error)}`);
                    fetchError = `${error}`;
                    break;
                }

                progressUptoThisFetch += progressWeighting;
            }

            fetchError ?
                reject(fetchError):
                resolve();
        } catch (error) {
            reject(error);
        }
    })
}

export function downloadMedium(auth: IAuthenticationManager, medium: string|IMediumDto): Promise<Blob> {
    const mediumId: string =
        ((medium as IMediumDto)?.id != undefined) ?
            String((medium as IMediumDto).id ?? -1) :
            String(medium);

    return new Promise(async function(resolve, reject) {
        try {
            const accessToken = await auth.renew();

            const blob = getMedia(accessToken, mediumId);

            resolve(blob);
        } catch (error) {
            reject(error);
        }
    })
};

const exports = {
    downloadAll,
    downloadMedium,
}

export default exports;
